import { render, staticRenderFns } from "./Paylate.vue?vue&type=template&id=02303d74"
import script from "./Paylate.vue?vue&type=script&lang=js"
export * from "./Paylate.vue?vue&type=script&lang=js"
import style0 from "./Paylate.vue?vue&type=style&index=0&id=02303d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports